import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { I18n, translate } from '@td/shared_utils';
import { Modal } from 'app/components';
import styles from './styles.module.scss';

const ConfirmationModal = ({ content, onClose, onConfirm, confirmBtnText }) => {
  const TITLE = translate(null, 'video.multiple_attendees_alert.title').toUpperCase();

  return (
    <Modal dialogClass={styles.confirmationDialog} title={TITLE} onExit={onClose}>
      <div>
        <div className={styles.modalContent}>
          { content }
        </div>
      </div>
      <div className={styles.buttonsList}>
        <button type="button" className={cx('button secondary button-cancel', styles.button)} onClick={onClose}>
          <I18n scope="video.multiple_attendees_alert.buttons" text="cancel" />
        </button>
        <button type="button" className={cx('button button-confirm', styles.button)} onClick={onConfirm}>
          <I18n scope="video.multiple_attendees_alert.buttons" text={confirmBtnText} />
        </button>
      </div>
    </Modal>
  );
};

ConfirmationModal.propTypes = {
  content:   PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  onClose:   PropTypes.func,
  onConfirm: PropTypes.func
};

export default ConfirmationModal;
